import { defineMessages } from 'react-intl';

export default defineMessages({
    hoTypeOfIncident: {
        id: 'fnol.ho.views.ho-what.Type of Incident',
        defaultMessage: 'Type of Incident'
    },
    hoFireDamage: {
        id: 'fnol.ho.views.ho-what.Fire',
        defaultMessage: 'Fire'
    },
    hoWaterDamage: {
        id: 'fnol.ho.views.ho-what.Water',
        defaultMessage: 'Water'
    },
    hoWindDamage: {
        id: 'fnol.ho.views.ho-what.Wind',
        defaultMessage: 'Wind'
    },
    hoCriminalDamage: {
        id: 'fnol.ho.views.ho-what.Theft/Vandalism',
        defaultMessage: 'Theft/Vandalism'
    },
    hoOtherDamage: {
        id: 'fnol.ho.views.ho-what.Other',
        defaultMessage: 'Other'
    },
    lossCauseType: {
        id: 'fnol.ho.views.ho-what.Loss Cause',
        defaultMessage: 'Loss Cause'
    },
    fireDamageHeader: {
        id: 'fnol.ho.views.ho-fire-details.Details (Fire Damage)',
        defaultMessage: 'Details (Fire Damage)'
    },
    fireCause: {
        id: 'fnol.ho.views.ho-fire-details.What caused the fire (if you know)?',
        defaultMessage: 'What caused the fire (if you know)?'
    },
    arsonInvolved: {
        id: 'fnol.ho.views.ho-fire-details.Arson involved',
        defaultMessage: 'Arson involved?'
    },
    sourceOfFire: {
        id: 'fnol.ho.views.ho-fire-details.Source of fire',
        defaultMessage: 'Source of the fire'
    },
    fireDiscovered: {
        id: 'fnol.ho.views.ho-fire-details.How was the fire discovered?',
        defaultMessage: 'How was the fire discovered?'
    },
    isHomeHabitable: {
        id: 'fnol.ho.views.ho-fire-details.Is the home habitable?',
        defaultMessage: 'Is the home habitable?'
    },
    anyOtherDetailsID: {
        id: 'fnol.ho.views.ho-fire-details.Please describe the loss',
        defaultMessage: 'Please describe the loss'
    },
    choiceYes: {
        id: 'fnol.ho.views.ho-fire-details.Yes',
        defaultMessage: 'Yes'
    },
    choiceNo: {
        id: 'fnol.ho.views.ho-fire-details.No',
        defaultMessage: 'No'
    },
    choiceNotSure: {
        id: 'fnol.ho.views.ho-fire-details.I\'m not sure',
        defaultMessage: 'I\'m not sure'
    },
    isHomeSecure: {
        id: 'fnol.ho.views.ho-fire-details.Is the home secure',
        defaultMessage: 'Is the home secure?'
    },
    anyOtherDetails: {
        id: 'fnol.ho.views.ho-fire-details.Any other details?',
        defaultMessage: 'Any other details?'
    },
    waterDamageHeader: {
        id: 'fnol.ho.views.ho-water-details.Details (Water Damage)',
        defaultMessage: 'Details (Water Damage)'
    },
    typeOfDamage: {
        id: 'fnol.ho.views.ho-water-details.What was the type of damage?',
        defaultMessage: 'What was the type of damage?'
    },
    waterDamage: {
        id: 'fnol.ho.views.ho-water-details.Water Damage',
        defaultMessage: 'Water Damage'
    },
    moldDamage: {
        id: 'fnol.ho.views.ho-water-details.Mold',
        defaultMessage: 'Mold'
    },
    sourceOfWater: {
        id: 'fnol.ho.views.ho-water-details.What was the source of the water?',
        defaultMessage: 'What was the source of the water?'
    },
    plumbingSource: {
        id: 'fnol.ho.views.ho-water-details.Plumbing or Appliance',
        defaultMessage: 'Plumbing or Appliance'
    },
    roofLeakSource: {
        id: 'fnol.ho.views.ho-water-details.Roof Leak',
        defaultMessage: 'Roof Leak'
    },
    otherSource: {
        id: 'fnol.ho.views.ho-water-details.Other',
        defaultMessage: 'Other'
    },
    hasWaterTurnedOff: {
        id: 'fnol.ho.views.ho-water-details.Has the water been turned off?',
        defaultMessage: 'Has the water been turned off?'
    },
    waterChoiceYes: {
        id: 'fnol.ho.views.ho-water-details.Yes',
        defaultMessage: 'Yes'
    },
    waterChoiceNo: {
        id: 'fnol.ho.views.ho-water-details.No',
        defaultMessage: 'No'
    },
    windChoiceYes: {
        id: 'fnol.ho.views.ho-wind-details.Yes',
        defaultMessage: 'Yes'
    },
    windChoiceNo: {
        id: 'fnol.ho.views.ho-wind-details.No',
        defaultMessage: 'No'
    },
    waterChoiceNotSure: {
        id: 'fnol.ho.views.ho-water-details.I\'m not sure',
        defaultMessage: 'I\'m not sure'
    },
    anyOtherDetailsOfWater: {
        id: 'fnol.ho.views.ho-water-details.Any other details?',
        defaultMessage: 'Any other details?'
    },
    criminalDamageHeader: {
        id: 'fnol.ho.views.ho-crime-details.Details (Criminal Damage)',
        defaultMessage: 'Details (Criminal Damage)'
    },
    typeOfCrime: {
        id: 'fnol.ho.views.ho-crime-details.What type of crime took place?',
        defaultMessage: 'What type of crime took place?'
    },
    burglaryCrime: {
        id: 'fnol.ho.views.ho-crime-details.Burglary',
        defaultMessage: 'Burglary'
    },
    vandalismCrime: {
        id: 'fnol.ho.views.ho-crime-details.Vandalism',
        defaultMessage: 'Vandalism'
    },
    riotCrime: {
        id: 'fnol.ho.views.ho-crime-details.Riot or civil commotion',
        defaultMessage: 'Riot or civil commotion'
    },
    anyOtherDetailsCrime: {
        id: 'fnol.ho.views.ho-crime-details.Any other details',
        defaultMessage: 'Any other details?'
    },
    otherDamageDetailsHeader: {
        id: 'fnol.ho.views.ho-other-details.Details (Other Damage)',
        defaultMessage: 'Details (Other Damage)'
    },
    flowConfigErrorcreatingClaim: {
        id: 'fnol.ho.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    homeownersClaim: {
        id: 'fnol.ho.config.FlowConfig.An error occurred attempting to create homeowners claim.',
        defaultMessage: 'An error occurred attempting to create homeowners claim.'
    },
    draftClaim: {
        id: 'fnol.ho.config.FlowConfig.Creating homeowners draft claim...',
        defaultMessage: 'Creating homeowners draft claim...'
    },
    hoDetails: {
        id: 'fnol.wizard.step.ho.Details',
        defaultMessage: 'Details'
    },
    hoCreateDraftClaim: {
        id: 'fnol.ho.config.FlowConfig.Creating homeowners draft claim...',
        defaultMessage: 'Creating homeowners draft claim...'
    },
    hoCreateDraftErrorTitle: {
        id: 'fnol.ho.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    fireDeptRespondedID: {
        id: 'fnol.ho.views.ho-fire-details.Fire department responded?',
        defaultMessage: 'Fire department responded?'
    },
    eMSReponded_EYID: {
        id: 'fnol.ho.views.ho-fire-details.EMS responded?',
        defaultMessage: 'EMS responded?'
    },
    isAnyoneInjuredID: {
        id: 'fnol.ho.views.ho-fire-details.Is anyone injured?',
        defaultMessage: 'Is anyone injured?'
    },
    smokeDamageOnlyID: {
        id: 'fnol.ho.views.ho-fire-details.Smoke damage only?',
        defaultMessage: 'Smoke damage only?'
    },
    lossPropertyInfoLabel: {
        id: 'fnol.common.views.more-info.Property',
        defaultMessage: 'Property'
    },
    dwellingIncidentCheckbox: {
        id: 'fnol.ho.views.ho-heading-dwelling.Dwelling',
        defaultMessage: 'Dwelling'
    },
    dwellingIncidentDesc: {
        id: 'fnol.ho.views.ho-other-heading.Description',
        defaultMessage: 'Description'
    },
    personalPropertyIncidentCheckbox: {
        id: 'fnol.ho.views.ho-other-heading-dwelling.Personal Property',
        defaultMessage: 'Personal Property'
    },
    otherStructuresIncidentCheckbox: {
        id: 'fnol.ho.views.ho-other-heading-dwelling.Other Structures',
        defaultMessage: 'Other Structures'
    },
    livingExpensesIncidentCheckbox: {
        id: 'fnol.ho.views.ho-other-heading-dwelling.Living Expenses',
        defaultMessage: 'Living Expenses'
    },
    isRoofProtectedID: {
        id: 'fnol.ho.views.water-details.Is the roof damage tarpe',
        defaultMessage: 'Is the roof damage tarped?'
    },
    isHomeHabitable_EYID: {
        id: 'fnol.ho.views.ho-water-details.Is the home habitable?',
        defaultMessage: 'Is the home habitable?'
    },
    isHomeSecure_EYID: {
        id: 'fnol.ho.views.ho-water-details.Is the home secure?',
        defaultMessage: 'Is the home secure?'
    },
    hasWaterTurnedOffID: {
        id: 'fnol.ho.views.ho-water-details.Has the water been turned off?',
        defaultMessage: 'Has the water been turned off?'
    },
    windDamageDetailsHeader: {
        id: 'fnol.ho.views.ho-wind-details.Details (Wind Damage)',
        defaultMessage: 'Details (Wind Damage)'
    }
});
